const fetchDispatchDetails = async params => {
  const url = `${params?.getApiUrl()}/sxcl/v1/service-provider-profile/${params?.serviceProviderId}/dispatch`;
  const response = await params?.get(url);
  return response;
};

const fetchBasicDetails = async params => {
  const url = `${params?.getApiUrl()}/sxcl/v1/service-providers/${params?.serviceProviderId}`;
  const response = await params?.get(url);
  return response;
};

const submitDispatchDetails = async (params, data, permissions) => {
  const { plusoneExternalReferenceId, ...rest } = data;
  let updatedPageData = {
    ...rest,
  };
  if (permissions?.plusoneExternalReferenceId === 'WRITE') {
    updatedPageData = {
      plusoneExternalReferenceId,
      ...updatedPageData,
    };
  }
  const url = `${params?.getApiUrl()}/sxcl/v1/service-provider-profile/${params?.serviceProviderId}/dispatch`;
  const response = await params?.put(url, updatedPageData);
  return response;
};

const submitBasicDetails = async (params, data, defaultValues) => {
  const url = `${params?.getApiUrl()}/sxcl/v1/service-providers/${params?.serviceProviderId}`;
  if (data?.serviceProviderType?.value) {
    const requestData = {
      serviceProviderType: {
        id: data.serviceProviderType?.value,
      },
    };
    const response = await params?.put(url, requestData);
    return response;
  }
  return {
    ok: true,
    data: {
      serviceProviderType: {
        typeName: defaultValues.serviceProviderType?.label,
        id: defaultValues.serviceProviderType?.value,
      },
    },
  };
};

export {
  fetchDispatchDetails,
  fetchBasicDetails,
  submitDispatchDetails,
  submitBasicDetails,
};
